import { render, staticRenderFns } from "./data54.vue?vue&type=template&id=4366d9b1&scoped=true&"
import script from "./data54.vue?vue&type=script&lang=js&"
export * from "./data54.vue?vue&type=script&lang=js&"
import style1 from "./data54.vue?vue&type=style&index=1&id=4366d9b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4366d9b1",
  null
  
)

export default component.exports